'use client';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { PersonRound, QRRound, PhoneRound, CheckRound } from '@/public/images/icons/icons';
import { fadeInUp, viewportOnce } from '@/lib/animations';

export default function MerchantOnboarding() {
  const t = useTranslations('Merchants.Onboarding');

  const steps = [
    {
      number: '01',
      title: 'step_1_title',
      description: 'step_1_desc',
      icon: <PersonRound width={50} height={50} className="shrink-0" />
    },
    {
      number: '02',
      title: 'step_2_title',
      description: 'step_2_desc',
      icon: <QRRound width={50} height={50} className="shrink-0" />
    },
    {
      number: '03',
      title: 'step_3_title',
      description: 'step_3_desc',
      icon: <PhoneRound width={50} height={50} className="shrink-0" />
    },
    {
      number: '04',
      title: 'step_4_title',
      description: 'step_4_desc',
      icon: <CheckRound width={50} height={50} className="shrink-0" />
    },
  ];

  return (
    <motion.section
      aria-labelledby="onboarding-heading"
      id="how-it-works"
      className="w-full bg-[#F4F8FF] py-16 sm:py-24 px-6 sm:px-10 lg:px-16"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeInUp}
    >
      <div className="max-w-8xl mx-auto space-y-12">
        <h2 id="onboarding-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">
          {t('title')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white rounded-3xl p-8 shadow-sm flex flex-col justify-between items-start transition-all hover:shadow-lg"
            >
              <div className="w-full space-y-6">
                <span className="text-base font-extrabold color-primary tracking-wide block">
                  {step.number}
                </span>
                <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0`}>
                  {step.icon}
                </div>
                <div className="space-y-3">
                  <h3 className="text-xl font-semibold text-gray-900 tracking-tight leading-snug">
                    {t(step.title)}
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-500 font-normal leading-relaxed">
                    {t(step.description)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="pt-2 text-xs sm:text-sm text-gray-500 font-normal space-y-1">
          <p>
            {t.rich('merchant_contact', {
              highlight: (chunks) => <span className="color-purple">{chunks}</span>,
              br: () => <br />,
            })}
          </p>
        </div>

      </div>
    </motion.section>
  );
}